// extracted by mini-css-extract-plugin
export default {"upsellCardWrapper":"EditImageUpsell_upsellCardWrapper__+JLKL"};